import { IPoint2d } from '@/editor/math/IPoint2d';

export enum EMaterialType {
  Floor = 0,
  WallFace = 1,
  GlassFace = 2
}

/**
 * 材质原始数据类型
 *
 * 用于与后端接口数据对应，在前端业务中请使用 ILibraryMaterial 类型
 */
export interface ILibraryMaterialRaw {
  id: string;
  name: string;
  key: string;
  type: EMaterialType;
  /** 材质 URL */
  materialUrl: string;
  display: {
    thumbnail: string;
    images: Record<string, string>;
  };
  properties: {
    brand?: string;
    price?: number;
    size?: {
      width: number;
      height: number;
    };
  };
}

/**
 * 材质数据类型
 */
export interface ILibraryMaterial {
  id: ILibraryMaterialRaw['key'];
  texture: ILibraryMaterialRaw['materialUrl'];
  name: ILibraryMaterialRaw['name'];
  type: EMaterialType;
  properties: ILibraryMaterialRaw['properties'];
  display: {
    thumbnail: string;
    images: {
      key: string;
      url: string;
    }[];
  };
}

export interface ILibraryModelCategoryRaw {
  id: string;
  name: string;
  sortOrder: number;
}

export interface ILibraryModelCategory {
  id: ILibraryModelCategoryRaw['id'];
  name: ILibraryModelCategoryRaw['name'];
}

/**
 * 模型原始数据类型
 *
 * 用于与后端接口数据对应，在前端业务中请使用 ILibraryModel 类型
 */
export interface ILibraryModelRaw {
  id: string;
  name: string;
  key: string;
  category: ILibraryModelCategoryRaw['id'][];
  model2d: string;
  model3d: string;
  type: string;
  properties: {
    width: number;
    thickness: number;
    height: number;
    offGround: number;
    rotationZ: number;
    model2dSvg: string;
    model2dExportSvg?: string;
    seats: number;
    wp: IPoint2d[];
    brand: string;
    size: string;
    price: number;
  };
  display: {
    thumbnail: string;
    images: Record<string, string>;
  };
}

export interface ILibraryModel {
  id: ILibraryModelRaw['key'];
  name: ILibraryModelRaw['name'];
  category: ILibraryModelRaw['category'];
  model2d: ILibraryModelRaw['properties']['model2dSvg'];
  model2dExport: ILibraryModelRaw['properties']['model2dExportSvg'];
  model3d: ILibraryModelRaw['model3d'];
  type: ILibraryModelRaw['type'];
  properties: Omit<ILibraryModelRaw['properties'], 'model2dSvg'>;
  display: {
    thumbnail: string;
    images: {
      key: string;
      url: string;
    }[];
  };
}
